module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/about-f5d4be56b867372944e574d3ab43062f.png";